import { c as _c } from "react/compiler-runtime";
import React, { useState, useEffect, useRef, useCallback } from 'react';
import PropTypes from 'prop-types';
import ToolbarIconButton from 'components/consumer/ToolbarIconButton';
import Link from 'components/consumer/Link';
import useUserData from 'data-hooks/useUserData';
import DropdownItem from './DropdownItem';
const HeaderToolbarDropdown = t0 => {
  const $ = _c(22);
  const {
    icon,
    title: t1,
    dropdownItems: t2,
    children,
    iconClassName: t3,
    "data-xc": t4
  } = t0;
  const title = t1 === undefined ? "" : t1;
  let t5;
  if ($[0] !== t2) {
    t5 = t2 === undefined ? [] : t2;
    $[0] = t2;
    $[1] = t5;
  } else {
    t5 = $[1];
  }
  const dropdownItems = t5;
  const iconClassName = t3 === undefined ? "" : t3;
  const dataXc = t4 === undefined ? "" : t4;
  const {
    isLoggedIn
  } = useUserData();
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const dropdownContainerRef = useRef(null);
  let t6;
  if ($[2] !== isDropdownOpen) {
    t6 = () => {
      setIsDropdownOpen(!isDropdownOpen);
    };
    $[2] = isDropdownOpen;
    $[3] = t6;
  } else {
    t6 = $[3];
  }
  const onDropdownButtonClick = t6;
  let t7;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = event => {
      if (dropdownContainerRef.current && !dropdownContainerRef.current.contains(event.target)) {
        setIsDropdownOpen(false);
      }
    };
    $[4] = t7;
  } else {
    t7 = $[4];
  }
  const handleClickOutside = t7;
  let t8;
  let t9;
  if ($[5] !== isDropdownOpen) {
    t8 = () => {
      if (!isDropdownOpen) {
        return;
      }
      document.addEventListener("mousedown", handleClickOutside);
      return () => document.removeEventListener("mousedown", handleClickOutside);
    };
    t9 = [isDropdownOpen, handleClickOutside];
    $[5] = isDropdownOpen;
    $[6] = t8;
    $[7] = t9;
  } else {
    t8 = $[6];
    t9 = $[7];
  }
  useEffect(t8, t9);
  const t10 = `max-[1023px]:hidden ${iconClassName}`;
  let t11;
  if ($[8] !== dataXc || $[9] !== icon || $[10] !== onDropdownButtonClick || $[11] !== t10 || $[12] !== title) {
    t11 = <ToolbarIconButton data-xc={dataXc} icon={icon} onClick={onDropdownButtonClick} title={title} className={t10} />;
    $[8] = dataXc;
    $[9] = icon;
    $[10] = onDropdownButtonClick;
    $[11] = t10;
    $[12] = title;
    $[13] = t11;
  } else {
    t11 = $[13];
  }
  let t12;
  if ($[14] !== children || $[15] !== dropdownItems || $[16] !== isDropdownOpen || $[17] !== isLoggedIn) {
    t12 = isDropdownOpen && <div className="absolute min-w-[8rem] top-12 right-0 bg-white border border-gray-light5">{children || dropdownItems?.map((item, index) => item?.link ? <Link to={isLoggedIn && item?.loggedInLink ? item?.loggedInLink : item?.link} key={item?.text} className="background:none] border-0 focus-visible:outline-offset-4 hover:text-brand hover:underline"><DropdownItem isLoggedIn={isLoggedIn} item={item} index={index} /></Link> : item?.onClick ? <div onClick={item?.onClick} role="button" tabIndex={0} key={item?.text}><DropdownItem item={item} index={index} /></div> : <DropdownItem item={item} index={index} key={item?.text} />)}</div>;
    $[14] = children;
    $[15] = dropdownItems;
    $[16] = isDropdownOpen;
    $[17] = isLoggedIn;
    $[18] = t12;
  } else {
    t12 = $[18];
  }
  let t13;
  if ($[19] !== t11 || $[20] !== t12) {
    t13 = <div ref={dropdownContainerRef} className="relative">{t11}{t12}</div>;
    $[19] = t11;
    $[20] = t12;
    $[21] = t13;
  } else {
    t13 = $[21];
  }
  return t13;
};
HeaderToolbarDropdown.propTypes = {
  icon: PropTypes.node.isRequired,
  title: PropTypes.string,
  dropdownItems: PropTypes.arrayOf(PropTypes.object),
  children: PropTypes.node,
  iconClassName: PropTypes.string,
  'data-xc': PropTypes.string
};
export default HeaderToolbarDropdown;